import { LclWeightBracketPrice } from "./lcl-weight-bracket-price.model";

export class LclWeightBracketPriceMapper {
  static map(data: any): LclWeightBracketPrice {
    return new LclWeightBracketPrice(data.name, data.value);
  }
}
